import styled, { css } from 'styled-components';
import { Container } from 'components/GridSystem';
import { Wrapper as FloatButtonStyle } from 'components/FloatPlaidButton/style';
import UnstyledFooter from 'components/Footer';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    min-height: 100%;

    @media (max-width: 576px) {
      min-height: 100%;
    }
  `}
`;
export const Main = styled.main`
  min-height: 100%;

  ${FloatButtonStyle} {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9;
  }
`;

export const WelcomeContainer = styled(Container)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.purple10};

    padding-top: 20px;
    padding-bottom: 20px;

    p {
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 2.4rem;

      color: ${theme.colors.neutralSilver70};
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 2.8rem;
    line-height: 3.4rem;

    color: ${theme.colors.neutralGray70};
  `}
`;

export const PaymentDetails = styled.section`
  margin-top: 40px;
  height: 100%;
`;

export const PaymentHeader = styled.div`
  ${({ theme }) => css`
    padding: 6px 24px;
    width: 100%;

    background: ${theme.colors.neutralGray5};

    border-bottom: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 8px 8px 0px 0px;
  `}
`;

export const HeaderTitle = styled.h2`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.4rem;

    margin-bottom: 0;

    color: ${theme.colors.neutralGray80};
  `}
`;

export const PaymentItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 16px 32px;

    background: ${theme.colors.neutralSilver5};
  `}
`;

export const PaidValue = styled.h3`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 2.4rem;

    color: ${theme.colors.purple100};
  `}
`;

export const ItemTitle = styled.div`
  ${({ theme }) => css`
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 2.2rem;

    color: ${theme.colors.purple100};
  `}
`;

export const DateItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 10px;

    p {
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 2.4rem;

      color: ${theme.colors.purple100};
    }
  `}
`;

export const Footer = styled(UnstyledFooter)`
  margin-top: 120px;
  margin-bottom: 150px;
`;
